export default function (el, { oldValue, value }) {
  if (value >= 0 && oldValue === value) return

  el.classList.remove('animation-zoomBounce2')

  setTimeout(() => {
    el.classList.add('animation-zoomBounce2')
  }, 0)
}
